import { getByCodeEventIdOnly } from 'components/graphql/queries/ticket';
import React from 'react';
import { fetchGraphQL } from 'services/graphql/GraphQL';

import EventPublicPage from 'pages/event/public/Detail.page';

class RedirectComponent extends React.Component<{ [label: string]: any }, { [label: string]: any }> {

    constructor(props) {
        super(props);
        this.fetch = this.fetch.bind(this)
        this.state = {
            eventId: '',
            loading: true,
            ticketCode: ''
        }
    }

    public componentDidMount() {
        const url = window.location.href;
        const urlItems = url.split('/')
        const subdomain = urlItems[2].split('.')[0];

        if (subdomain !== 'platform'
            && subdomain !== 'test'
            && subdomain !== 'localhost:3000') {
            // Referral ticket link
            fetchGraphQL(`
            query {
                    url {
                        getLinkBySubdomainAndReferral(subdomain:"${subdomain}",code:"${this.props.match.params.ticketCode}") 
                    }
                }
            `).then(res => {
                if (res && res.url && res.url.getLinkBySubdomainAndReferral) {
                    window.location.href = 'https://platform.isotopeticketing.com' + res.url.getLinkBySubdomainAndReferral
                }
            })
        } else {
            this.fetch();
        }

    }
    public fetch() {
        fetchGraphQL(getByCodeEventIdOnly(),
            undefined,
            {
                ticketCode: this.props.match.params.ticketCode
            }
        ).then((res) => {

            if (res.ticket) {
                if (res.ticket.get) {
                    if (res.ticket.get.eventId !== null && res.ticket.get.eventId !== undefined) {
                        // this.props.history.push('event/' + res.ticket.get.eventId + '/ticket/' + this.props.match.params.ticketCode)
                        this.setState({
                            eventId: res.ticket.get.eventId,
                            loading: false,
                            ticketCode: this.props.match.params.ticketCode,
                            promoterId: res.ticket.get.promoterId
                        })
                    }
                }
            }
        })
    }
    public render() {
        if (this.state.loading || this.state.eventId === '' || this.state.ticketCode === '') {
            return null;
        } else {
            return <EventPublicPage {...this.props} eventId={this.state.eventId} ticketCode={this.state.ticketCode} promoterId={this.state.promoterId} />
        }
    }
}

export default RedirectComponent;



// WEBPACK FOOTER //
// ./src/components/redirect/redirect.tsx